export default "__VITE_ASSET__DEgBJzAd__"